import { render } from 'preact';
import '@/styles/global.css';
import { App } from '@/app';

declare const __APP_VERSION__: number;
declare global { interface Window { version: number } }

window.version = __APP_VERSION__;
console.log(`Boostly frontend version ${__APP_VERSION__}`);

const root = document.getElementById('app');
if (root) render(<App/>, root);
